var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13",
    "data-name": "Group 13",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.018,
    height: 16.401,
    viewBox: "0 0 18.018 16.401",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M45.086,34.023V40.37H41.224V34.449c0-1.487-.558-2.5-1.956-2.5a2.1,2.1,0,0,0-1.981,1.345,2.408,2.408,0,0,0-.128.9v6.18H33.295s.052-10.028,0-11.066h3.863v1.568c-.008.012-.019.024-.026.036h.026v-.036a3.869,3.869,0,0,1,3.481-1.828c2.541,0,4.447,1.582,4.447,4.98ZM29.254,23.969a1.927,1.927,0,1,0-.051,3.824h.025a1.928,1.928,0,1,0,.026-3.824ZM27.3,40.37h3.862V29.3H27.3Z",
    transform: "translate(-27.068 -23.969)",
    fill: "#4b85c7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.8ef385043effba448757ac79b56cc62d.svg";
export { ForwardRef as ReactComponent };